import { Link } from "react-router-dom";

const S = ({ t, children }) => (
  <section className="mt-8">
    <h2 className="font-display text-xl font-bold text-slate-900">{t}</h2>
    <div className="mt-2 space-y-2 text-slate-600">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div className="min-h-screen bg-slate-50 px-6 py-12">
      <div className="mx-auto max-w-3xl rounded-xl border border-slate-200 bg-white p-8 shadow-sm" data-testid="privacy-page">
        <Link to="/login" className="text-sm font-semibold text-amber-700">← Voltar</Link>
        <h1 className="mt-4 font-display text-4xl font-extrabold text-slate-900">Política de Privacidade</h1>
        <p className="mt-2 text-sm text-slate-500">Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).</p>
        <S t="1. Dados tratados">Dados de cadastro (nome, e-mail), dados dos estabelecimentos, informações de pedidos e evidências (imagens) enviadas pelo próprio restaurante para análise de contestações.</S>
        <S t="2. Finalidade">Os dados são utilizados exclusivamente para analisar ocorrências, gerar contestações e respostas, manter o histórico e exibir indicadores do próprio estabelecimento.</S>
        <S t="3. Processamento das análises">Textos e imagens do caso são processados de forma segura por fornecedores de tecnologia contratados, apenas para a análise solicitada. As credenciais de acesso ficam protegidas no servidor e nunca são expostas no navegador.</S>
        <S t="4. Armazenamento e integridade">As imagens são guardadas em armazenamento privado, acessíveis somente pelo estabelecimento proprietário. Os arquivos originais são preservados e nunca alterados.</S>
        <S t="5. Dados de clientes finais">Recomendamos não incluir dados pessoais desnecessários dos clientes (telefone, endereço). As respostas públicas geradas evitam a exposição de dados pessoais.</S>
        <S t="6. Direitos do titular">Você pode exportar todos os seus dados ou excluir sua conta a qualquer momento em Configurações → Privacidade e dados.</S>
        <S t="7. Contato">Dúvidas sobre privacidade: entre em contato com o administrador da plataforma.</S>
      </div>
    </div>
  );
}
